export default "__VITE_ASSET__DjAT50Rk__"